import { makeUniqueId } from '@apollo/client/utilities';
import React from 'react';
import {
  Card,
  Button,
  Label,
  Input,
  Row,
  Col,
  InputGroup,
  InputGroupText,
  Form
} from 'reactstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { UpdateFreemiumInfo } from '../../../../graphql/Mutation';
import { useMutation } from '@apollo/client';

const Days = Array(30)
  .fill()
  .map((_, idx) => (
    <option key={makeUniqueId(`earn_credit_${idx}_`)} value={idx + 1}>
      {idx + 1}
    </option>
  ));

const ValidationSchema = yup.object().shape({
  freemiumDays: yup.number().required('This field is required'),
  newLabelDays: yup.number().required('This field is required')
});

export const FreemiumSettingsModule = ({ data }) => {
  const [updateFreemiumInfo] = useMutation(UpdateFreemiumInfo);

  const onSubmit = async (data, { errors }) => {
    if (!errors) {
      const check = {
        freemiumDays: parseInt(data['freemiumDays']),
        newLabelDays: parseInt(data['newLabelDays'])
      };

      await updateFreemiumInfo({
        variables: {
          updateFreemiumData: check
        }
      });
    }
  };

  return (
    <Card body>
      <Formik
        initialValues={{
          ...data
        }}
        validateOnChange
        validateOnBlur
        validationSchema={ValidationSchema}
        onSubmit={onSubmit}
      >
        {({ values, handleChange, handleBlur, handleSubmit, errors }) => (
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col>
                <Label tag="h5" for="freemiumDays" color="black">
                  Días Freemium
                </Label>
                <InputGroup className="mb-2">
                  <Input
                    name="freemiumDays"
                    id="freemiumDays"
                    onChange={handleChange}
                    type="select"
                    onBlur={handleBlur}
                    invalid={errors.freemiumDays && true}
                    value={values.freemiumDays}
                  >
                    {Days}
                  </Input>
                  <InputGroupText>Dias</InputGroupText>
                </InputGroup>
              </Col>
              <Col>
                <Label tag="h5" for="newLabelDays">
                  Etiqueta Nuevo
                </Label>
                <InputGroup className="mb-2">
                  <Input
                    type="select"
                    name="newLabelDays"
                    id="newLabelDays"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    invalid={errors.newLabelDays && true}
                    value={values.newLabelDays}
                  >
                    {Days}
                  </Input>
                  <InputGroupText>Dias</InputGroupText>
                </InputGroup>
              </Col>
              <Col className="d-flex justify-content-center align-items-center">
                <Button
                  type="submit"
                  color="primary"
                  style={{
                    height: '40px'
                  }}
                >
                  Actualizar
                </Button>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </Card>
  );
};
